import {
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	HostBinding,
	OnInit,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { WithDynamicContent } from '@woolworthsnz/dynamic-content';
import { ACCOUNT_PATH } from '@woolworthsnz/shop/routes';
import {
	AlertType,
	AlertComponent,
	WappleLoadingComponent,
	PageHeadingComponent,
	LoggingService,
} from '@woolworthsnz/styleguide';
import { filter, take } from 'rxjs/operators';
import { NgIf } from '@angular/common';

@WithDynamicContent()
@Component({
	selector: 'wnz-authentication-page',
	template: `
		<ng-container *ngIf="!loading; else loader">
			<cdx-page-heading>
				<cdx-alert *ngIf="hasPopupBlocker" [type]="alertType" [title]="popupBlockerMessage"> </cdx-alert>

				<h1 i18n="Sign in or register heading@@loginRegister-pageHeader" class="heading--display">
					{{ heading }}
				</h1>
			</cdx-page-heading>

			<router-outlet></router-outlet>
		</ng-container>
		<ng-template #loader>
			<cdx-wapple-loading></cdx-wapple-loading>
		</ng-template>
	`,
	styleUrls: ['./authentication.page.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgIf, PageHeadingComponent, AlertComponent, RouterOutlet, WappleLoadingComponent],
})
export class AuthenticationPage implements OnInit, AfterViewInit {
	@HostBinding('class.authPage') authPage = true;
	loading = true;
	heading: string;
	hasPopupBlocker = false;
	popupBlockerMessage = [
		'Please turn off your ad-blocker, or whitelist www.countdown.co.nz in your ad-blocker settings, as the content of the Countdown Online Shopping website may be blocked by this software.',
	];
	alertType = AlertType.error;

	constructor(
		private cdr: ChangeDetectorRef,
		private route: ActivatedRoute,
		private router: Router,
		private loggingService: LoggingService
	) {}

	ngOnInit(): void {
		this.sessionInitHandler();
		this.setHeading();
	}

	sessionInitHandler(event?: any): void {
		if (event && event.detail && event.detail.email) {
			this.router.navigateByUrl(`/${ACCOUNT_PATH}`);
			return;
		}
		this.loading = false;
		this.cdr.markForCheck();
	}

	ngAfterViewInit(): void {
		document.addEventListener('error', this.resourceFailed, true);

		this.router.events
			.pipe(
				take(1),
				filter((event) => event instanceof NavigationEnd)
			)
			.subscribe(() => {
				this.setHeading();
			});
	}

	resourceFailed = (error: any): void => {
		if (error && error.target && error.target.tagName === 'SCRIPT') {
			if (error.target.src.indexOf('cdn') !== -1 && error.target.src.indexOf('gigya.com') !== -1) {
				this.hasPopupBlocker = true;
				this.loggingService.trackException({ error });
			}
		}
	};

	setHeading = (): void => {
		this.heading = this.route.snapshot.firstChild?.data?.heading;

		this.cdr.markForCheck();
	};
}
